import axios from 'axios'
import Vue from 'vue'
import { Notify} from 'vant';
Vue.use(Notify)

// 创建axios实例
const service = axios.create({
 /* baseURL: debug ? 'Cabinet' :'http://106.55.62.117:9090/',  //api的baseURL */
  // baseURL: 'http://192.168.3.161:9090/',

  // baseURL: 'http://81.70.145.108:19098/', // 测试接口

  // baseURL: 'https://sjzps.weelook.com/', //正式地址
  // baseURL: 'http://81.70.145.108:19099/',
  // baseURL:'http://192.168.3.174:19099/',

  baseURL:'https://www.weelook.com/',
  timeout: 150000 // 请求超时取消
})

// 添加请求拦截器
service.interceptors.request.use(function (config) {
    // 在发送请求之前做些什么
    if(localStorage.getItem('Authorization')){
        config.headers.Authorization = localStorage.getItem('Authorization')
    }
    return config

}, error => {
  // 处理请求错误
  console.log(error) // 打印错误信息
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(

  response => {
   
     /**
     * code为非0是抛错
     */
    const res = response.data
    if (res.code !== 0) {
    Notify({type:'warning',message:res.msg,duration:3*1000})
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    console.log('err' + error)// for debug
    // // Notify({type:'warning',message:'登录已失效，请退出后重新登录',duration:3*1000})
    // Notify({type:'warning',message:error,duration:3*1000})
    // return Promise.reject(error)
    if(error){
      if(error.response){
        if(error.response.status === 401){
          Notify({type:'warning',message:'登录已失效，请退出后重新登录',duration:3*1000})
        }else if(error.response.status === 403){
          Notify({type:'warning',message:'当前账号没有该操作权限',duration:3*1000})
        }
        else{
          Notify({type:'warning',message:error,duration:3*1000})
        }
      }
    }
    return Promise.reject(error)
  }
)

export default service
